/***
 * Mixin for retrieving the Google Analytics LinkerParam to be used
 * for cross-domain tracking.
 *
 * Check the GTM for implementation details.
 * */
export default {
  mounted() {
    this.refresh();
    // The linkingParam expires every 2minutes
    this.gaLinkingParamPoller = setInterval(this.refresh, 5000); // every 5sec
  },
  data() {
    return {
      gaLinkingParamPoller: null,
      gaLinkingParam: null
    };
  },
  methods: {
    refresh() {
      // window.googleAnalyticsLinkingParam is set in google tag manager
      return this.gaLinkingParam = window.googleAnalyticsLinkingParam;
    }
  },
  computed: {
    gaLinkingParamKey() {
      return this.gaLinkingParam?.split("=")[0]
    },
    gaLinkingParamValue() {
      return this.gaLinkingParam?.split("=")[1]
    }
  },
  beforeDestroy() {
    if (this.gaLinkingParamPoller) {
      clearInterval(this.gaLinkingParamPoller)
    }
  }
};